<template>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <input @keyup.enter="saveView" type="text" v-model="viewTitle" placeholder="Enter view title" class="form-control" ref="focusThis" />
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <button class="btn btn-primary" type="button" @click="saveView" data-dismiss="modal">Save</button>
        <button class="btn btn-secondary" v-if="hasCancelButton" type="button" @click="cancelAction" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import toast from '../../toast';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    viewId: {
      default: ''
    },
    hasCancelButton: {
      default: false,
    }
  },
  data() {
    return {
      viewTitle: this.title != '' ? this.title : '',
    };
  },
  computed: {
    ...mapGetters(['deliverableFilter', 'myWeekDeliverableFilter', 'mediaCallFilter', 'projectFilter', 'myProjectFilter', 'socialMediaFilter']),
  },
  mounted() {
    this.focusMyElement();
  },
  methods: {
    focusMyElement() {
      if(typeof this.$refs.focusThis != 'undefined') {
        let that = this;
        setTimeout(function() {
          that.$refs.focusThis.focus();
        }, 100);
      }
    },
    saveView() {
      let view = "";
      if (this.$router.currentRoute.name == "dashboard") {
        view = this.deliverableFilter;
        localStorage.setItem('dashboardActiveSaveTitle', this.viewTitle);
        localStorage.setItem('dashboardActiveSaveData', JSON.stringify(view));
      } else if (this.$router.currentRoute.name == "myWeek") {
        view = this.myWeekDeliverableFilter;
        localStorage.setItem('myWeekActiveSaveTitle', this.viewTitle);
        localStorage.setItem('myWeekActiveSaveData', JSON.stringify(view));
      } else if (this.$router.currentRoute.name == "mediaCallPage") {
        view = this.mediaCallFilter;
        localStorage.setItem('mediaCallActiveSaveTitle', this.viewTitle);
        localStorage.setItem('mediaCallActiveSaveData', JSON.stringify(view));
      } else if (this.$router.currentRoute.name == "project") {
        view = this.projectFilter;
        localStorage.setItem('projectActiveSaveTitle', this.viewTitle);
        localStorage.setItem('projectActiveSaveData', JSON.stringify(view));
      } else if (this.$router.currentRoute.name == "myProjects") {
        view = this.myProjectFilter;
        localStorage.setItem('myProjectActiveSaveTitle', this.viewTitle);
        localStorage.setItem('myProjectActiveSaveData', JSON.stringify(view));
      } else if (this.$router.currentRoute.name == "socialMedia" || this.$router.currentRoute.name == "socialMediaGrouped" || this.$router.currentRoute.name == "socialMediaSchedule") {
        view = this.socialMediaFilter;
        localStorage.setItem('socialMediaActiveSaveTitle', this.viewTitle);
        localStorage.setItem('socialMediaActiveSaveData', JSON.stringify(view));
      }
      
      let type = '';
      if(this.$router.currentRoute.name == "project" || this.$router.currentRoute.name == "myProjects") {
        type = 'project';
      } else if (this.$router.currentRoute.name == "socialMedia" || this.$router.currentRoute.name == "socialMediaGrouped" || this.$router.currentRoute.name == "socialMediaSchedule") {
        type = 'socialMedia';
      } else {
        type = 'deliverable';
      }

      let viewData = {
        title: this.viewTitle,
        filterQuery: view,
        viewId: this.viewId,
        viewType: type
      };
      let that = this;
      this.$store.dispatch("saveView", viewData).then(function() {
        toast.info('View has been saved.');
        if(that.viewId != '') {
          that.$root.$emit('hideUpdateText');
        }
        that.$emit('setActiveView');
        that.viewId == '' ? that.$bvModal.hide("viewTitleModal") : that.$bvModal.hide("viewTitleUpdateModal");
      });
    },
    cancelAction() {
      this.$emit('cancelEdit');
    },
  },
};
</script>

<style>
</style>